<div>
  <nz-page-header class="bg-slate-100" [nzGhost]="false">
    <nz-page-header-title class="text-primary flex flex-col gap-1 !mb-0">
      <div class="flex items-center gap-2">
        {{ 'itineraryTemplates.list.title' | transloco }}
        <nz-icon nz-tooltip
                 nzTooltipPlacement="right"
                 [nzTooltipArrowPointAtCenter]="true"
                 [nzTooltipTitle]="'nav.featureTooltips.itineraryTemplates' | transloco"
                 [nzTooltipOverlayStyle]="{
                       'max-width': '400px',
                       'min-width': '300px',
                       'white-space': 'normal',
                       'line-height': '1.5'
                     }"
                 nz-icon nzType="info-circle" nzTheme="outline">
        </nz-icon>
      </div>
      <!-- <span class="text-sm text-gray-500 font-normal leading-normal">
        {{ 'itineraryTemplates.list.subtitle' | transloco }}
      </span> -->
    </nz-page-header-title>
    <nz-page-header-extra>
      <nz-space class="flex flex-col-reverse md:flex-row justify-end gap-3">
        <div class="mt-2 md:mt-0">
          <nz-input-group nzSearch [nzAddOnAfter]="suffixButton" [nzSuffix]="inputClearTpl">
            <input
              type="text"
              nz-input
              [placeholder]="'itineraryTemplates.list.searchPlaceholder' | transloco"
              (keydown.enter)="this.search()"
              [(ngModel)]="itinerarySearchName"/>
          </nz-input-group>
          <ng-template #inputClearTpl>
                <span
                  *ngIf="itinerarySearchName"
                  nz-icon
                  class="ant-input-clear-icon"
                  nzTheme="fill"
                  nzType="close-circle"
                  (click)="reset()"
                ></span>
          </ng-template>
          <ng-template #suffixButton>
            <button
              nz-button
              nzType="primary"
              (click)="search()"
              nzSearch>
              {{ 'itineraryTemplates.list.searchButton' | transloco }}
            </button>
          </ng-template>
        </div>
        <div>
          <button
            *appHasAnyPrivilege="'ITINERARY.TEMPLATE.ADD'"
            nz-button
            nzType="primary"
            routerLink="/admin/template-itinerary/add" class="flex items-center justify-center gap-2">
            <lucide-icon name="plus" class="icon-size"></lucide-icon>
            {{ 'itineraryTemplates.list.newTemplateButton' | transloco }}
          </button>
        </div>
      </nz-space>
    </nz-page-header-extra>
  </nz-page-header>
</div>
<div class="my-4 mx-5" *appHasAnyPrivilege="'ITINERARY.TEMPLATE.VIEW'">
  <nz-table
    #templateTable
    [nzData]="itineraryTemplates"
    [nzShowSizeChanger]="pageSize.length > 5"
    [nzPageSizeOptions]="pageSize.pageSizeOptions"
    [nzBordered]="true"
    [nzPageSize]="pageSize.pageSize"
    [nzPageIndex]="pageSize.pageIndex"
    [nzFrontPagination]="false"
    [nzTotal]="pageSize.length"
    (nzQueryParams)="onTableParamsChange($event)"
    [nzScroll]="{ x: '1400px' }">
    <thead>
    <tr>
      <th nzWidth="180px">
        {{ 'itineraryTemplates.table.templateTitle' | transloco }}
      </th>
      <th nzWidth="140px">
        {{ 'itineraryTemplates.table.country' | transloco }}
      </th>
      <th nzWidth="160px">
        {{ 'itineraryTemplates.table.duration' | transloco }}
      </th>
      <th nzWidth="140px" [nzSortFn]="sortColumn.compareName" (click)="sortByCategory()">
        {{ 'itineraryTemplates.table.category' | transloco }}
      </th>
      <th nzWidth="140px" [nzSortFn]="sortColumn.compareDate" (click)="sortByDate()">
        {{ 'itineraryTemplates.table.createdDate' | transloco }}
      </th>
      <th nzWidth="140px" [nzSortFn]="sortColumn.compareName" (click)="sortByCreator()">
        {{ 'itineraryTemplates.table.creator' | transloco }}
      </th>
      <th nzWidth="80px">
        {{ 'itineraryTemplates.table.pax' | transloco }}
      </th>
      <th nzWidth="120px" [nzSortFn]="sortColumn.compareName" (click)="sortByLanguage()">
        {{ 'itineraryTemplates.table.language' | transloco }}
      </th>
      <th nzWidth="100px" [nzSortFn]="sortColumn.compareName" (click)="sortByCurrency()">
        {{ 'itineraryTemplates.table.currency' | transloco }}
      </th>
      <th nzWidth="140px" [nzSortFn]="sortColumn.compareDate" (click)="sortByUpdatedAt()">
        {{ 'itineraryTemplates.table.lastUpdated' | transloco }}
      </th>
      <th nzWidth="450px">{{ 'itineraryTemplates.table.actions' | transloco }}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of templateTable.data">
      <td>
        {{ data?.title !== '' ? data?.title : getEmptyValue() }}
      </td>
      <td class="text-center">
       {{ countrySequence(data?.days)}}
      </td>
      <td>
        {{ data?.tour?.noOfDays ? getDurationLabel(data.tour.noOfDays) : getEmptyValue() }}
      </td>
      <td class="text-center">
        <nz-tag *ngIf="data?.tour?.category?.name" nzColor="purple">{{ data.tour.category.name }}</nz-tag>
        <span *ngIf="!data?.tour?.category?.name">{{ getEmptyValue() }}</span>
      </td>
      <td>{{ data.createdAt | date }}</td>
      <td>
        <span>{{ data.creator?.name || getEmptyValue() }}</span>
      </td>
      <td>{{ data.tour?.pax?.adults + data.tour?.pax?.children }}</td>
      <td class="capitalize">{{ languageByCode(data.tour?.language) }}</td>
      <td class="uppercase">{{ data.tour?.currency }}</td>
      <td>{{ data.updatedAt | date }}</td>
      <td>
        <div class="flex flex-row items-center gap-2">
          <button
            *appHasAnyPrivilege="'ITINERARY.TEMPLATE.EDIT'"
            nz-button
            nzType="default"
            nzSize="small"
            (click)="onEdit(data)"
            class="flex items-center justify-center gap-2">
            <lucide-icon name="pencil" class="icon-size"></lucide-icon>
            {{ 'itineraryTemplates.table.edit' | transloco }}
          </button>
          <button
            nz-button
            nzType="primary"
            nzSize="small"
            (click)="onPreview(data)"
            class="flex items-center justify-center gap-2">
            <lucide-icon name="eye" class="icon-size"></lucide-icon>
          </button>
          <button
            *appHasAnyPrivilege="'ITINERARY.TEMPLATE.USE'"
            nz-button
            nzType="primary"
            nzSize="small"
            (click)="onUseTemplate(data)"
            class="flex items-center justify-center gap-2">
            <lucide-icon name="wand-sparkles" class="icon-size"></lucide-icon>
            {{ 'itineraryTemplates.table.useTemplate' | transloco }}
          </button>
          <button
            *appHasAnyPrivilege="'ITINERARY.TEMPLATE.DELETE'"
            nz-button
            nzType="default"
            nzSize="small"
            nzDanger
            (click)="showDeleteConfirm(data._id)"
            class="flex items-center justify-center gap-2">
            <lucide-icon name="trash-2" class="icon-size"></lucide-icon>
          </button>
        </div>
        <!-- <div class="flex flex-row items-center gap-2 mt-2">
          <button
            *appHasAnyPrivilege="'ITINERARY.TEMPLATE.USE'"
            nz-button
            nzType="primary"
            nzSize="small"
            (click)="onUseTemplate(data)"
            class="flex items-center justify-center gap-2">
            <lucide-icon name="wand-sparkles" class="icon-size"></lucide-icon>
            {{ 'itineraryTemplates.table.useTemplate' | transloco }}
          </button>
        </div> -->
      </td>
    </tr>
    </tbody>
  </nz-table>
</div>
